import { FC } from 'react';
import Icon, { type IconIds, type IconProps } from 'src/common/components/IconDS22';
import getClassNames from 'src/common/utils/getClassNames';
import type { AddonSubType } from 'src/common/types/common/Addons';
import classNames from 'classnames';
import styles from './AddonIcon.module.scss';

type AddonIconSizes = 'small' | 'medium';
export type AddonIconProps = {
  iconName: IconIds;
  /** Controls background color. If needed, use `ensureAddonSubtype`, which defaults to blue. */
  subType: AddonSubType;
  size?: AddonIconSizes;
  withBorder?: boolean;
};

const iconSize: Record<AddonIconSizes, IconProps['size']> = {
  small: 'l',
  medium: 'xl',
};

const subTypeToClassName: Record<AddonSubType, string> = {
  1: 'blue',
  2: 'gray',
  3: 'red',
  4: 'yellow',
  5: 'green',
  6: 'orange',
  7: 'pink',
  8: 'blue',
  9: 'gray',
};

const AddonIcon: FC<AddonIconProps> = ({
  iconName,
  subType,
  size = 'medium',
  withBorder,
}) => (
  <div
    className={getClassNames(
      styles,
      'root',
      classNames(
        size,
        subTypeToClassName[subType?.toString()],
        {
          withBorder,
        },
      ),
    )}
  >
    <Icon
      size={iconSize[size]}
      id={iconName}
    />
  </div>
);

export default AddonIcon;
